<template>
  <div class="page-login text-center pl-3 pr-3 pb-3 pt-2">
    <div class="toolbar text-right mb-4">
      <b-dropdown size="lg" variant="link" class="dropdown-languages mr-1" right v-if="language != null">
        <template #button-content>
          <img :src="`images/flags/${language.code}.png`"/> {{ language.name }}
        </template>
        <b-dropdown-item href="#" v-for="(lang, index) in languages" :active="lang.code == language.code" :key="index"
                         @click.prevent="setLanguageCode(lang.code)">
          <img :src="`images/flags/${lang.code}.png`"/> {{ lang.name }}
        </b-dropdown-item>
      </b-dropdown>
      <a href="/" @click.prevent="openProxySettings" v-b-tooltip.hover :title="$t('Proxy settings')">
        <img src="images/ico-settings.png"/>
      </a>
    </div>

    <div class="mb-5 d-block logo">
      <img src="images/full-logo.png" alt="logo" style="max-width: 100%; width: 300px"/>
    </div>

    <div class="d-block ml-auto mr-auto" style="width: 400px; max-width: 100%">
      <b-button pill size="lg" class="btn-block mb-3 btn-trans-white" @click="$router.push({name: 'LogIn'})">{{ $t("Log In") }}</b-button>
      <b-button pill size="lg" class="btn-block mb-3 btn-trans-white" @click="$router.push({name: 'FreeJoin'})">{{ $t("Free Join a Meeting") }}</b-button>
      <b-button pill size="lg" class="btn-block btn-trans-white" @click="$router.push({name: 'SignUp'})">{{ $t("Sign Up") }}</b-button>
    </div>
    <ProxySettingsModal ref="proxySettingsModal" />
    <PanelLoading :show="showLoading"/>
  </div>
</template>

<script>
import appHelper from "../helpers/app_helper";
import jwt from "jsonwebtoken";
import authenticateService from "../services/authenticate_service";
import ProxySettingsModal from "../components/ProxySettingsModal";

export default {
  name: "Main",
  components: {ProxySettingsModal},
  data: function () {
    return {
      languages: [],
      language: null,
      showLoading: true
    }
  },
  methods: {
    openProxySettings: function () {
      this.$refs.proxySettingsModal.open();
    },
    setLanguageCode: function (code, save = true) {
      this.languages = appHelper.settings.languages;
      this.language = this.languages.find(x => x.code === code);
      if (save)
        this.$store.dispatch("setLanguageCode", code);
    }
  },
  created: async function () {
    // Check login info
    let loginInfo = await appHelper.getSetting("loginInfo");
    try {
      if (loginInfo && typeof loginInfo === "object" && typeof loginInfo.username === "string" && loginInfo.username.length > 0) {
        loginInfo.password = jwt.verify(loginInfo.password, loginInfo.username);
        const response = await authenticateService.logIn(loginInfo);
        if (response != null && response.startsWith("OK|")) {
          let responseData = JSON.parse(response.substr(3));
          await this.$store.dispatch("setUserInfo", {
            username: loginInfo.username,
            password: loginInfo.password,
            tempPwd: responseData.TempPwd,
            transId: responseData.TransID,
            storeLink: responseData.StoreLink,
            deviceId: appHelper.settings.macAddress
          })

          await this.$store.dispatch("setMainButtons", responseData.ButtonsLable);

          this.showLoading = false;
          await this.$router.push({name: "Home"});
          return;
        }
      }
    } catch (e) {
      console.log(e);
    }

    this.showLoading = false;
    console.log("Current language: " + this.$store.getters.languageCode);
    this.setLanguageCode(this.$store.getters.languageCode, false);
  },
  beforeCreate() {
    this.setTitle();
  }
}
</script>
